<h2 class="row space-between align-center">
    <div>
        @if(isNew){
            <span>New</span>
        }@else{
            <span>Edit</span>
        } Category
    </div>
</h2>
<form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" class="col gap-16 w100">
    <rr-input formControlName="name" label="Name of Category"></rr-input>
    <rr-textarea formControlName="description" label="Description of Category"></rr-textarea>
    <div class="col gap-4 w100">
        <span class="color-strong row space-between w100"
          >Select Image
          <rr-btn type="link" (click)="clearImage($event)">clear Image</rr-btn>
        </span>
        <div class="imagearea row">
          @for(image of imageList; track image){
          <img [src]="frontendurl + '/public/catimages/thumbs/' + image" (click)="selectImage(image)" [ngClass]="{'selected': categoryForm.value.image == image}">
          }
        </div>
      </div>
        <span class="color-strong row space-between w100"
          >Select Tags
          <rr-btn type="link" (click)="clearTags($event)">clear all Tags</rr-btn>
        </span>
        <div class="tag-row" *ngIf="categoryForm.value.tags"><rr-badge *ngFor="let tag of categoryForm.value.tags" [icon]="tag.icon" [tone]="getColorOfTag(tag)" (click)="removeTag(tag)" style="cursor: pointer;">{{tag.name}}</rr-badge></div>
        <mat-tree #tree [dataSource]="groupedTags" [childrenAccessor]="childrenAccessor">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="addTag(node)">
                <rr-badge [icon]="node.icon" [tone]="getColorOfTag(node)" style="cursor: pointer;" style="cursor: pointer;">{{node.name}}</rr-badge>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodeToggle [cdkTreeNodeTypeaheadLabel]="node.name">
                <rr-icon name="chevron-down"></rr-icon><div>{{node.name}}</div>
            </mat-tree-node>
        </mat-tree>
        <rr-select [options]="statuses" optionName="name" optionValue="id" class="w100 grow-1" label="Status" formControlName="status" [preselectedValue]="categoryForm.value.status"></rr-select>
    <div class="row gap-8 align-end w100 justify-end">
        <rr-btn (click)="cancel($event)">Cancel</rr-btn>
        <rr-btn type="Primary">Save</rr-btn>
    </div>
</form>